import { createSelector } from 'reselect';

import { getDefaultOptInValue } from '../brand/brandSelectors';


export const getSenderData = state => state.get('sender');

export const getSenderOptIn = createSelector(
    getSenderData, getDefaultOptInValue,
    (sender, defaultVal) => {
        const selectedVal = sender.get('optIn');
        
        
        if (typeof selectedVal === 'undefined') {
            return defaultVal;
        }
        return selectedVal;
    }
);
